<div class="customers">
    <div class="divObjetivo">
        <div class="card-body">
            <div class="form-special-padding">
                <div class="row">
                    <div class="col-sm-4" style="background-color: #E8EAF5;">
                        <textarea class="text-area-objetivo" name="consulta" (change)="change()" [(ngModel)]="accionData.accion" [disabled]="readonly"></textarea>
                    </div>
                    <div class="col-sm-4" style="background-color: #E8EAF5;">
                        <div class="input-group p-3">
                            <div class="jornada">
                                <div class="row">
                                    <div class="col-6 p-2">
                                        Desde:
                                    </div>
                                    <div class="col-6 p-2">
                                        Hasta:
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="input-group p-2">
                                            <div class="input-group-append">
                                                <button class="btn btn-calendar" (click)="d1.toggle()" style="width: 40px;padding: 12px 12px;" type="button" [disabled]="readonly">
                                                    <i class="fas fa-calendar-alt"></i>
                                                </button>
                                            </div>
                                            <input class="form-control input-fecha" [ngClass]="fechaClass" style="padding: 6px 12px;" name="fechaInicioMedicion" [(ngModel)]="this.fechaInicio" ngbDatepicker #d1="ngbDatepicker" (ngModelChange)="change()" readonly>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="input-group p-2">
                                            <div class="input-group-append">
                                                <button class="btn btn-calendar" (click)="d2.toggle()" style="width: 40px;padding: 12px 12px;" type="button" [disabled]="readonly"> 
                                                    <i class="fas fa-calendar-alt"></i>
                                                </button>
                                            </div>
                                            <input class="form-control input-fecha" [ngClass]="fechaClass" style="padding: 6px 12px;" name="fechaFinMedicion" [(ngModel)]="this.fechaFin" ngbDatepicker #d2="ngbDatepicker" (ngModelChange)="change()" readonly>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 p-2">
                                        <button class="btn btn-calendar-clear" (click)="clearDateInicio()" type="button" [disabled]="readonly"> 
                                            <i class="fas fa-trash-alt"></i>
                                        </button>
                                    </div>
                                    <div class="col-6 p-2">
                                        <button class="btn btn-calendar-clear" (click)="clearDateFin()" type="button" [disabled]="readonly"> 
                                            <i class="fas fa-trash-alt"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4" style="background-color: #E8EAF5;">
                        <textarea class="text-area-objetivo" name="consulta" (change)="change()" [(ngModel)]="accionData.medioVerificacion" [disabled]="readonly"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>